<template>
	<div class="index">
		<div class="index-div">
			<div class="banner">
				<img :src="banner|Ximgurl" />
			</div>
			<div class="title" style="font-size: 0.875rem;">推荐作者</div>
			<div class="swiper">
				<swiper class="mySwiper" :options="swiperOption"
				        ref="mySwiper">
				  
				    <swiper-slide class="div1"  v-for="(item,index) in sponsor" :key="index">
						<router-link :to="'/author?sponsor_id='+item.id">
							<img :src="item.avatar" />
							<div class="name">{{item.username}}</div>
							<div class="ding">
								<div>订阅</div>
							</div>
						</router-link>
					</swiper-slide>
					
					
					
					<!-- <div class="swiper-pagination" slot="pagination"></div> -->
				    <div class="swiper-button-prev" slot="button-prev"></div>
				    <div class="swiper-button-next" slot="button-next"></div>
				</swiper>
			</div>
			<div class="index-conent">
				<div class="index-conent-left">
					<div class="index-conent-left-header">
						<div>推荐竞赛</div>
						<div><router-link to="/game/list">更多</router-link></div>
					</div>
					<div class="index-conent-left-connet">
						
						<div class="list-div" v-for="(item,index) in gamehotlist" :key="index">
							<router-link :to="'/game/details?id='+item.id">
							<img :src="item.img" />
							<div class="list-div-title">主办方：{{item.name}}</div>
							<div class="list-div-bao">
								<div>{{item.type}}</div>
								<div class="enter">进入</div>
							</div>
							
							</router-link>
						</div>
					
					</div>
					
					<div class="index-conent-left-header">
						<div>精选题库</div>
						
						<div><router-link to="/question/ku_list">更多</router-link></div>
					</div>
				
					<div class="index-conent-left-connet1">
						<div class="list-div" v-for="(item,index) in hotTlist" :key="index">
							
							<router-link :to="'/question/details?id='+item.id">
							<div class="list-div-titleh2">{{item.name}}</div>
							<img class="img1" :src="item.img" />
							<div class="list-div-title">
								<img :src="item.merchant.avatar" />
								<div>{{item.merchant.username}}</div>
								<div>{{item.count}}道题</div>
							</div>
							<div class="list-div-bao">
								{{item.brief}}
							</div>
							<div class="list-div-top">
								<div>更新于：{{item.update_time|slice}}</div>
								<div></div>
							</div>
							</router-link>
						</div>
						
						
					</div>
					
					<div class="index-conent-left-header">
						<div>精选题型</div>
						<div><router-link to="/question/ti_list">更多</router-link></div>
					</div>
					<div class="index-conent-left-connet1">
						<div class="list-div" v-for="(item,index) in hotOlist" :key="index">
							<router-link :to="'/topic/beaker?id='+item.id">
							<div class="list-div-titleh2">
								<div>{{item.name}}</div>
								<div>ID：{{item.id}}</div>
							</div>
							<img  style="height: 9rem"  class="img1":src="item.img|Ximgurl" />
							<div class="list-div-bao1">
								<div>难易度</div>
								<div>
									<img v-if="item.difficulty>=1" src="../../assets/shudo/images/11.svg" />
									<img v-if="item.difficulty>=2" src="../../assets/shudo/images/11.svg" />
									<img v-if="item.difficulty>=3" src="../../assets/shudo/images/11.svg" />
									<img v-if="item.difficulty>=4" src="../../assets/shudo/images/11.svg" />
									<img v-if="item.difficulty>=5" src="../../assets/shudo/images/11.svg" />
									
								</div>
							</div>
							<div class="list-div-top1">
								<div>
									
									<img :src="item.merchant.avatar" />
									<div style="min-width: 3rem;">{{item.merchant.username}}</div>
								</div>
								<div>
									
								</div>
								
								
							</div>
							</router-link>
						</div>
						
					</div>
				
				</div>
				<div class="index-conent-right">
					<!-- 签到 -->
					<!-- <div class="sign">
						<div class="sign-div">
							<div>每日签到</div>
							<div>排行榜</div>
						</div>
						<div class="sign-div1">
							<div class="sign-div1-left">
								<img src="../../assets/shudo/images/2.svg" />
								<span>请登陆后签到</span>
							</div>
							<div class="sign-div1-right">
								<span>注册</span>
							</div>
						</div>
					</div> -->
					<!-- 加入圈子 -->
					<div class="sign">
						<div class="sign-div">
							<div>加入圈子</div>
							<div>QQ群|微信群</div>
						</div>
						<div class="sign-div1" v-for="(item,index) in wxchat" :key="index">
							<div class="sign-left">
								<img :src="item.img" />
							</div>
							<div class="sign-conent">{{item.name}}</div>
							<div class="sign-right" @click="join(item.type,item.number)">加入</div>
						</div>
						
					</div>
					<!-- 热门文章 -->
					<div class="sign">
						<div class="sign-div">
							<div>热门文章</div>
							
							<div><router-link to="/article/list">更多</router-link></div>
							
						</div>
						
						<div class="sign-div2"  v-for="(item,index) in articlehotlist" :key="index" @click="article(item.id)">
							<div class="sign-left">
									
								<img :src="item.img|Ximgurl" />
							</div>
							<div class="sign-conent">
								<div>{{item.title}}</div>
								<div>{{item.create_time}}</div>
							</div>
							
						</div>
						
					
					</div>
					
					<!-- 推荐主办方 -->
					<div class="sign">
						<div class="sign-div">
							<div>推荐主办方</div>
							<div>更多</div>
						</div>
						<div class="sign-div3" v-for="(item,index) in merchanthotlist" :key="index">
							<router-link :to="'/sponsor?merchanthot_id='+item.id" style="display: flex;">
							<div class="sign-left">
								<img :src="item.avatar" />
							</div>
							<div class="sign-conent" style="line-height: 2.1875rem; font-size: 0.9375rem; padding-left: 1rem;">
								{{item.username}}
							</div>
							</router-link>
						</div>
						
					
					</div>
					
					<!-- 推荐用户 -->
					<div class="sign">
						<div class="sign-div">
							<div>推荐用户</div>
							<div>更多</div>
						</div>
						<div class="sign-div3" v-for="(item,index) in userhotlist" :key="index">
							<router-link :to="'/touser?user_id='+item.id" style="display: flex;">
							<div class="sign-left">
								
								<img :src="item.avatar" style="width: 2.1875rem;" />
							</div>
							<div class="sign-conent" style="padding-left: 12px;">
								<div>{{item.username}}</div>
								<div v-if="item.nationality">
									<!-- <div>杭州</div> -->
									<!-- <div>最强大脑第四季选手</div> -->
									
									<div>{{item.nationality}}|{{item.city}}</div>
									<!-- <div>{{item.label}}</div> -->
								</div>
							</div>
							</router-link>
						</div>
						
					
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<style lang="less">
	@import  '../../../common/css/index.less';
	.lunbotu {
	    // width: 90%;
	    // height: 300px;
	}
</style>
<script>
	
	 import { swiper, swiperSlide } from "vue-awesome-swiper";
	
	  export default {
		  components: {
		      swiper,
		      swiperSlide
		  },
		data() {
			return {
				sponsor   : [],
				banner    :  '',
				hotTlist  :  [],  //精选题型
				hotOlist  :  [],  //精选题库
				wxchat    :  [],  //联系方式
				gamehotlist: [],  //比赛列表
				articlehotlist : [], //文章列表
				merchanthotlist : [],//主办方
				userhotlist  : [], //推荐用户
				swiperOption:{
				    slidesPerView: 6,  //一行显示3个
				    spaceBetween: 40,  //间隔30
				    freeMode: true,
				    speed: 1000,   //滑动速度
				    navigation: {
				        nextEl: '.swiper-button-next',
				        prevEl: '.swiper-button-prev',
				    },
					 // 显示分页
					 pagination: {
					   el: ".swiper-pagination",
					   clickable: true //允许分页点击跳转
					 },
				},
			}	
		},
		created() {
			this.getlist();
			console.log(222);
		},
	    methods: {
			getlist(){
				let that = this;
				that.$http('get','/api/v1/config?name=banner',{}) .then(function (res) {
					that.banner = res.data;
				});
				that.$http('get','/api/v1/classify/hotTlist?hot=1',{}) .then(function (res) {  //题型
					that.hotOlist = res.data.list;
				});
				that.$http('get','/api/v1/classify/hotOlist?hot=1',{}) .then(function (res) {  //题库
					that.hotTlist = res.data.list;
				});
				that.$http('get','/api/v1/wxchat',{}) .then(function (res) {  //联系方式
					that.wxchat = res.data;
				});
				that.$http('get','/api/v1/article/hotlist',{}) .then(function (res) {  //文章列表
					that.articlehotlist  = res.data.list;
					
				});
				that.$http('get','/api/v1/game/hotlist',{}) .then(function (res) {  //比赛列表
					that.gamehotlist  = res.data.list;
					
				});
				that.$http('get','/api/v1/merchant/hotlist',{}) .then(function (res) {  //主办方
					that.merchanthotlist  = res.data.list;
				});
				that.$http('get','/api/v1/user/hotlist',{}) .then(function (res) {  //推荐用户
					that.userhotlist  = res.data.list;
				});
				that.$http('get','/api/v1/sponsor/list',{}) .then(function (res) {  //推荐作者
					that.sponsor  = res.data.list;
					
				});
				
				
				
			},
			join(type,number){
				let that = this;
				type = type == 0 ? '微信' : 'QQ'; 
				that.$alert(type+':'+number, '联系方式', {
				    confirmButtonText: '确定',
				    callback: action => {
				      
				    }
				});
				console.log(number);
			},
			article(id){
				this.$router.push('/articledetails?id='+id);
			},
			onSwiper(swiper) {
				console.log(swiper);
			},
			onSlideChange() {
				console.log('slide change');
			},
	    },
	}


</script>


